export enum Tela {
  lead = 1,
  cotacao = 2,
}
